import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { backendUrl } from "../../../rootUrl";
import { productSlice } from "../product/productSlice";
import {
  activateUser,
  resendActivateCode,
  sendCode,
} from "./authAC";

const signin = backendUrl + "/api/auth/sign-in/";
// const loginUrl = backendUrl + "/api/auth/login/";
// const registerUrl = backendUrl + "/api/auth/register/";
const getProfileUrl = backendUrl + "/api/auth/profile-list/";
const updateProfileUrl = backendUrl + "/api/auth/profile-create/";

const getAddressUrl = backendUrl + "/api/auth/address-list/";
const updateAddressUrl = backendUrl + "/api/auth/address-create/";
const createAddressUrl = backendUrl + "/api/auth/address-create/";
const deleteAddressUrl = backendUrl + "/api/auth/address-delete/";

const createOrderUrl = backendUrl + "/api/order/order-create/";
const getOrderUrl = backendUrl + "/api/order/order-list/";
const getOrderDetailUrl = backendUrl + "/api/order/order-detail/";
const getOrderPaymentUrl = backendUrl + "/api/order/payment/";

const getPaymentUrl = backendUrl + "/api/order/orderid-request/?orderId=";
const getCheckPaymentUrl = backendUrl + "/api/order/check-payment/";

const initialState = {
  token: "",
  refresh: "",
  username: "",
  isAuthenticated: false,
  isPhoneVerified: false,
  redirectToSms: false,
  isLoading: false,
  isSmsSent: false,
  successMessage: "",
  smsResponse: "",
  verifyResponse: "",
  verifyMessage: "",
  loginError: "",
  address: [],
  profile: [],
  orders: "",
  orderDetail: "",
  order: "",
  payment: "",
};

export const getProfileInfo = createAsyncThunk(
  "auth/getProfileInfo",
  async ({ token }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.get(getProfileUrl, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const updateProfileInfo = createAsyncThunk(
  "auth/updateProfileInfo",
  async ({ token, formData }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.put(updateProfileUrl, formData, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const getAddressInfo = createAsyncThunk(
  "auth/getAddressInfo",
  async ({ token }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.get(getAddressUrl, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const createAddressInfo = createAsyncThunk(
  "auth/createAddressInfo",
  async ({ token, formData }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.post(createAddressUrl, formData, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const updateAddressInfo = createAsyncThunk(
  "auth/updateAddressInfo",
  async ({ token, formData }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.put(updateAddressUrl, formData, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const deleteAddressInfo = createAsyncThunk(
  "auth/deleteAddressInfo",
  async ({ token, id }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      await axios.delete(deleteAddressUrl + id + "/", config);
      return id;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);
export const getCheckPaymentInfo = createAsyncThunk(
  "auth/getCheckPaymentInfo",
  async ({ id, bank, token }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      let fullUrl = getCheckPaymentUrl + id + "/?bank=" + bank;
      const { data } = await axios.get(fullUrl, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const getPaymentInfo = createAsyncThunk(
  "auth/getPaymentInfo",
  async ({ order_id }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let fullUrl = getPaymentUrl + order_id;
      const { data } = await axios.get(fullUrl, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const getOrderInfo = createAsyncThunk(
  "auth/getOrderInfo",
  async ({ url, token }, { rejectWithValue }) => {
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      let fullUrl = getOrderUrl + url;
      const { data } = await axios.get(fullUrl, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const getOrderDetailInfo = createAsyncThunk(
  "auth/getOrderDetailInfo",
  async ({ id, token }, { rejectWithValue }) => {
    const getOrderDetailUrls = getOrderDetailUrl + id + "/";
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.get(getOrderDetailUrls, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);

export const createOrderInfo = createAsyncThunk(
  "auth/createOrderInfo",
  async (
    { token, json, successFunc, errorFunc },
    { rejectWithValue, dispatch }
  ) => {
    dispatch(productSlice.actions.setUnavailableProducts([]));
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      const { data, status } = await axios.post(createOrderUrl, json, config);
      if (status === 222 || data.message === "Some products isn't exist") {
        toast.error("Некоторые продукты отсутствуют на складе");
        // console.log(e.response.data.data)
        errorFunc();
        dispatch(productSlice.actions.setUnavailableProducts(data.data));
        return rejectWithValue(data.data);
      }
      successFunc();
      return data;
    } catch (e) {
      if (e.response.data.message === "Some products isn't exist") {
        toast.error("Некоторые продукты отсутствуют на складе");
        // console.log(e.response.data.data)
        errorFunc();
        dispatch(
          productSlice.actions.setUnavailableProducts(e.response.data.data)
        );

        return rejectWithValue(e.response.data.data);
      } else {
        errorFunc();
        toast.error("something went wrong");
        return rejectWithValue("something went wrong");
      }
    }
  }
);

export const getOrderPaymentInfo = createAsyncThunk(
  "auth/getOrderPaymentInfo",
  async ({ id, bank, token }, { rejectWithValue }) => {
    const getOrderPaymentUrls = getOrderPaymentUrl + id + "/?bank=" + bank;
    try {
      var config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      const { data } = await axios.get(getOrderPaymentUrls, config);
      return data;
    } catch {
      rejectWithValue("something went wrong");
    }
  }
);



export const userLogin = createAsyncThunk(
  "auth/login",
  async ({ username }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        signin,
        { username },
        config
      );
      return data;
    } catch (err) {
      if (err.response.status === 401) {
        const lang = localStorage.getItem("userLanguage");
        return rejectWithValue(lang === 'tm' ? "Ulanyjy belgisi nädogry" : "Неправильное имя пользователя ")
      }
      toast.error(err.response?.data?.message)
      return rejectWithValue(err.response.data.message);
    }
  }
);


export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutUser: () => initialState,
    setRedirectToSms: (state, action) => {
      state.redirectToSms = action.payload;
    },
    setErrorLogin: (state, action) => {
      state.loginError = action.payload
    },
    clearPaymentInfo(state) {
      state.order = "";
      state.payment = "";
    },
  },
  extraReducers: {
    [getProfileInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getProfileInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.profile = action?.payload["data"];
    },
    [getProfileInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [updateProfileInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [updateProfileInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.profile = action.payload["data"];
    },
    [updateProfileInfo.rejected]: (state) => {
      state.isLoading = false;
    },
    [getAddressInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getAddressInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.address = action.payload;
    },
    [getAddressInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [createAddressInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [createAddressInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.address.push({
        ...action.payload,
      });
    },
    [createAddressInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [updateAddressInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [updateAddressInfo.fulfilled]: (state, action) => {
      state.address = state.address.map((item) =>
        item.id === action.payload.id ? { ...action.payload } : item
      );
      state.isLoading = false;
    },
    [updateAddressInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [deleteAddressInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteAddressInfo.fulfilled]: (state, action) => {
      state.address = state.address.filter(
        (item) => item.id !== action.payload
      );
      state.isLoading = false;
    },
    [deleteAddressInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [getCheckPaymentInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getCheckPaymentInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.payment = action.payload;
    },
    [getCheckPaymentInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [getPaymentInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getPaymentInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.order = action.payload;
    },
    [getPaymentInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [getOrderInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getOrderInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.orders = action.payload["data"];
    },
    [getOrderInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [createOrderInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [createOrderInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
    },
    [createOrderInfo.rejected]: (state, action) => {
      state.isLoading = false;
    },

    [getOrderDetailInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getOrderDetailInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.orderDetail = action?.payload["data"];
    },
    [getOrderDetailInfo.rejected]: (state) => {
      state.isLoading = false;
    },

    [getOrderPaymentInfo.pending]: (state) => {
      state.isLoading = true;
    },
    [getOrderPaymentInfo.fulfilled]: (state, action) => {
      state.isLoading = false;
      window.location.href = action.payload.formUrl;
    },
    [getOrderPaymentInfo.rejected]: (state) => {
      state.isLoading = false;
    },
    // activate
    [activateUser.pending]: (state) => {
      state.isLoading = true;
      state.loginError = "";
    },
    [activateUser.fulfilled]: (state, { payload }) => {
      if (payload.response === "success") {
        state.isLoading = false;
        state.token = payload.data.token;
        state.isAuthenticated = true;
        state.username = payload.data.username;
        window.location.reload(false);
      } else {
        state.loginError = payload.message;
      }
    },
    [activateUser.rejected]: (state, action) => {
      state.loginError = action.payload.message 
      state.isLoading = false;
      state.isAuthenticated = false;
      state.login = action.payload.message;
    },

    // resend - activate
    [resendActivateCode.pending]: (state) => {
      // state.isLoading = true;
      state.loginError = "";
    },
    [resendActivateCode.fulfilled]: (state, { payload }) => {
      if (!payload.success) {
        state.loginError = payload.message;
      }
    },
    [resendActivateCode.rejected]: (state, action) => {
      state.loginError = action.payload.message
    },

    // send code for reset user password
    [sendCode.pending]: (state) => {
      // state.isLoading = true;
      state.loginError = "";
    },
    [sendCode.fulfilled]: (state, { payload }) => {
      if (!payload.success) {
        state.loginError = payload.message;
      }
    },
    [sendCode.rejected]: (state, action) => {
      state.loginError = action.payload.message;
    },
    // login

    [userLogin.pending]: (state) => {
      state.isLoading = true;
      state.loginError = ''
    },
    [userLogin.fulfilled]: (state) => {
      state.isLoading = false;
      state.redirectToSms = true;
    },
    [userLogin.rejected]: (state, action) => {
      state.isLoading = false;
      // state.loginError = action.payload;
    },
  },
});

export const { logoutUser } = authSlice.actions;
export const { clearPaymentInfo } = authSlice.actions;

export default authSlice.reducer;
